import Client from "@/repositories/Clients/AxiosClient";
import Config from "@/repositories/Clients/AxiosDefaultConfig";
import { prepareSearchParams } from "@/libs/helper";

const resource = `${Config.basePath}/question/answer/frequently/ask`;

export default {
  list(payload) {
    return Client.get(`${resource}`, {
      params: prepareSearchParams(payload),
    });
  },
  update(id, payload) {
    return Client.put(`${resource}/update/${id}`, {
      ...payload,
    });
  },
  destroy(id) {
    return Client.delete(`${resource}/delete/${id}`);
  },
  download(payload) {
    return Client.get(`${resource}/download`, {
      params: payload
    });
  },
};
